module.exports = __webpack_public_path__ + "static/media/5.6f28e8c9.webp";